var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3275 13.458C15.9182 13.8191 16.2291 14.2286 16.2291 14.6455C16.2291 15.0624 15.9182 15.472 15.3275 15.833C14.7369 16.1941 13.8875 16.4939 12.8645 16.7023C11.8415 16.9108 10.6811 17.0205 9.49992 17.0205C8.3187 17.0205 7.1583 16.9108 6.13534 16.7023C5.11237 16.4939 4.2629 16.1941 3.67229 15.833C3.08168 15.472 2.77075 15.0624 2.77075 14.6455C2.77075 14.2286 3.08168 13.8191 3.67229 13.458",
    stroke: "white",
    strokeWidth: 0.863636,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 7.91699C15.4375 11.5898 11.7235 14.1574 10.1703 15.0706C9.75263 15.3161 9.24738 15.3161 8.8297 15.0706C7.27646 14.1574 3.5625 11.5898 3.5625 7.91699C3.5625 4.35449 6.43942 1.97949 9.5 1.97949C12.6667 1.97949 15.4375 4.35449 15.4375 7.91699Z",
    stroke: "white",
    strokeWidth: 0.863636
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.49992,
    cy: 7.91667,
    r: 2.73485,
    stroke: "white",
    strokeWidth: 0.863636
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLight);
export default __webpack_public_path__ + "static/media/locationLight.3cd6e8c88b1d649deed872bd53eb8bc2.svg";
export { ForwardRef as ReactComponent };